import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";

export const sliderOtherTestimony = (slider: HTMLElement) => {
    new Swiper(slider, {
        modules: [Pagination, Navigation],
        pagination: {
            el: slider.querySelector('.swiper-pagination') as HTMLElement,
            clickable: true,
        },
        navigation: {
            nextEl: slider.querySelector('.swiper-button-next') as HTMLElement,
            prevEl: slider.querySelector('.swiper-button-prev') as HTMLElement,
        },
        breakpoints: {
            550: {
                slidesPerView: 2,
                spaceBetween: 20,
                allowSlideNext: true,
                allowSlidePrev: true,
                centeredSlides: true,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 24,
                allowSlideNext: true,
                allowSlidePrev: true,
                centeredSlides: true,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 24,
                allowSlideNext: false,
                allowSlidePrev: false,
                centeredSlides: false,
            },
        },
        slidesPerView: 1,
        spaceBetween: 24,
        centeredSlides: true,
        allowSlideNext: true,
        allowSlidePrev: true,
    })
}
